export type InstallmentLike = { status: string; due_date: string | null };

/** DB only stores "pending"; overdue is derived from due_date so nothing has to flip rows. */
export function effectiveInstallmentStatus(i: InstallmentLike, today: Date = new Date()): string {
  if (i.status !== "pending" || !i.due_date) return i.status;
  const due = new Date(i.due_date);
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return due < startOfToday ? "overdue" : "pending";
}
